import { render, staticRenderFns } from "./Suporte.vue?vue&type=template&id=61d10632"
import script from "./Suporte.vue?vue&type=script&lang=js"
export * from "./Suporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports